const API_PREFIX = '/api'

export const SSO_ATTEMPTED_KEY = '__ssoLoginAttempted__'
export const SSO_SESSION_EXPIRED_KEY = '__ssoSessionExpired__' // 登录态被踢出/过期标记，供错误页区分「会话失效」与「单点登录失败」
export const SSO_AUTHORIZE_PATH = `${API_PREFIX}/auth/sso/authorize`
export const SSO_CALLBACK_PATH = `${API_PREFIX}/auth/sso/callback`
export const SSO_ERROR_PATH = '/login/error' // 前端路由，不走代理前缀
export const SSO_LOGGED_OUT_PATH = '/login/loggedOut' // 主动登出后的提示页（前端路由，不走代理前缀）
